import React, { useState } from 'react';
import PropTypes from 'prop-types';

import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import DownloadIcon from '@mui/icons-material/Download';
import { FormControl, IconButton, InputAdornment } from '@mui/material';

import SaftModal from './SaftModal';

const DataTableHeader = ({ 
                           onClick,
                           onQueryChange,
                           queryString,
                           searchLabel = "Search Members",
                           filter,
                           showSaftModal = false,
                         }) => {
  const [openSaftModal, setOpenSaftModal] = useState(false);

  const handleDownload = () => {
    if (showSaftModal) {
      setOpenSaftModal(true);
    } else {
      onClick();
    }
  };

  return (
    <div className='data-table-header'>

      {filter && filter}

      { onQueryChange &&
        <FormControl sx={{'width' : 275}} size="small">
          <TextField label={searchLabel}
            type="search"
            size="small"
            value={queryString}
            color="warning"
            onChange={(e) => { onQueryChange(e.target.value) }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
      }
      {onClick &&
        <IconButton onClick={handleDownload}>
          <DownloadIcon />
        </IconButton>
      }
      {openSaftModal && (
        <SaftModal 
          open={openSaftModal} 
          onClose={() => setOpenSaftModal(false)}
          onClick={onClick}
        />
      )}
    </div>
  )
};

DataTableHeader.propTypes = {
  onClick: PropTypes.func,
  onQueryChange: PropTypes.func,
  queryString: PropTypes.string,
  searchLabel: PropTypes.string,
  filter: PropTypes.node,
  showSaftModal: PropTypes.bool,
};

export default DataTableHeader;
